@if (fieldPreview(); as fieldPreview) {
  @if (fieldPreview.error) {
    <IBadge
      [label]="fieldPreview.providedValue"
      [iTooltip]="fieldPreview.error"
      iTooltipPlacement="top-center"
      icon="alertTriangle"
      size="sm"
      color="red"
      variant="soft"
    />
  } @else if (formattedChangedValue(); as formattedChangedValue) {
    <span class="text-blue-500" [iTooltip]="formattedChangedValue" iTooltipPlacement="top-center">{{
      fieldPreview.providedValue === "" ? "-" : fieldPreview.parsedValue
    }}</span>
  } @else {
    @let isFieldUnchanged = !fieldPreview.isCreation && !fieldPreview.hasChanged;
    <span [ngClass]="isFieldUnchanged ? 'text-gray-400' : 'text-gray-700'">{{
      fieldPreview.providedValue === "" ? "-" : fieldPreview.parsedValue
    }}</span>
  }
}
